// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .App {
  font-family: sans-serif;
  background: #1c1d1f;
  color: white;
  height: 100vh;
} */

.react-tabs {
    display: flex;
    color: cyan;
    background: #03112c;
}

img.imageDim {
    filter: brightness(25%) !important;
}

.react-tabs__tab-list {
    display: flex;
    flex-direction: column;
    width: 60px;
    margin: 0;
    padding: 0;
    color: cyan;
    background: #0b1c3b;
    height: 100%;
}

.react-tabs__tab {
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    height: 40px;
    list-style: none;
    cursor: pointer;
    color: #bbb;
    font-weight: bold;
    width: 60px;
    font-size: 16px;
    border-left: 4px solid #0b1c3b;
}

.react-tabs__tab--selected {
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 60px;
    background: #03112c;
    border-color: #03112c;
    list-style: none;
    border-left: 4px solid cyan;
    color: cyan;
    font-weight: bold;
    font-size: 16px;
}

#ordered {
    height: 100%;
    display: block;
}

#tab-horizontal {
    display: block;
}

#tab-horizontal > .react-tabs__tab-list {
    flex-direction: row;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 40px;
    justify-content: space-around;
    align-items: center;
}

#tab-horizontal > .react-tabs__tab-list > .react-tabs__tab {
    width: auto;
    height: 100%;
    flex: 1 1;
    border-left: 0;
    padding-left: 4px;
    border-bottom: 4px solid rgba(0, 0, 0, 0);
}

#tab-horizontal > .react-tabs__tab-list > .react-tabs__tab--selected {
    height: 100%;
    border-left: 0;
    padding-left: 4px;
    border-bottom: 4px solid cyan;
}

#tab-horizontal > .react-tabs__tab-panel--selected {
    height: calc(100% - 40px);
    width: 100%;
}

.panel-content {
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/asset/style/workflow/tab-pane.css"],"names":[],"mappings":"AAAA;;;;;GAKG;;AAEH;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,SAAS;IACT,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,2BAA2B;IAC3B,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":["/* .App {\n  font-family: sans-serif;\n  background: #1c1d1f;\n  color: white;\n  height: 100vh;\n} */\n\n.react-tabs {\n    display: flex;\n    color: cyan;\n    background: #03112c;\n}\n\nimg.imageDim {\n    filter: brightness(25%) !important;\n}\n\n.react-tabs__tab-list {\n    display: flex;\n    flex-direction: column;\n    width: 60px;\n    margin: 0;\n    padding: 0;\n    color: cyan;\n    background: #0b1c3b;\n    height: 100%;\n}\n\n.react-tabs__tab {\n    display: flex;\n    align-content: center;\n    justify-content: center;\n    align-items: center;\n    height: 40px;\n    list-style: none;\n    cursor: pointer;\n    color: #bbb;\n    font-weight: bold;\n    width: 60px;\n    font-size: 16px;\n    border-left: 4px solid #0b1c3b;\n}\n\n.react-tabs__tab--selected {\n    display: flex;\n    align-content: center;\n    justify-content: center;\n    align-items: center;\n    height: 40px;\n    width: 60px;\n    background: #03112c;\n    border-color: #03112c;\n    list-style: none;\n    border-left: 4px solid cyan;\n    color: cyan;\n    font-weight: bold;\n    font-size: 16px;\n}\n\n#ordered {\n    height: 100%;\n    display: block;\n}\n\n#tab-horizontal {\n    display: block;\n}\n\n#tab-horizontal > .react-tabs__tab-list {\n    flex-direction: row;\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    height: 40px;\n    justify-content: space-around;\n    align-items: center;\n}\n\n#tab-horizontal > .react-tabs__tab-list > .react-tabs__tab {\n    width: auto;\n    height: 100%;\n    flex: 1 1;\n    border-left: 0;\n    padding-left: 4px;\n    border-bottom: 4px solid rgba(0, 0, 0, 0);\n}\n\n#tab-horizontal > .react-tabs__tab-list > .react-tabs__tab--selected {\n    height: 100%;\n    border-left: 0;\n    padding-left: 4px;\n    border-bottom: 4px solid cyan;\n}\n\n#tab-horizontal > .react-tabs__tab-panel--selected {\n    height: calc(100% - 40px);\n    width: 100%;\n}\n\n.panel-content {\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
